import { createReducer, on } from '@ngrx/store';

import { initialEnterprisesState } from './enterprises.state';
import {
  changeEnterprise,
  resetEnterprises,
  setEnterprises,
  triggerIsLoadingSelectedEnterprise,
} from './enterprises.actions';

import _ from 'lodash';

import { Utility } from 'src/services/utility.service';

import { Enterprise } from 'src/models/Enterprise';
import { Station } from 'src/models/Station';

import { EnStationTypes } from 'src/enums/EnStationTypes';

export const enterprisesReducer = createReducer(
  initialEnterprisesState,

  on(setEnterprises, (state, action) => {
    const enterprises: Enterprise[] = _.cloneDeep(action.enterprises);

    enterprises.forEach((enterprise) => {
      enterprise.stations.sort((stationA, stationB) =>
        stationA.name.localeCompare(stationB.name),
      );

      enterprise.stations.sort((stationA, stationB) =>
        compareStationType(stationA, stationB),
      );
    });

    Utility.setStore('enterprises', enterprises, true);

    const latestModificationOnUTC: Date =
      Enterprise.getLatestModificationOnUTCOfEnterprises(enterprises);

    Utility.setStore(
      'enterprisesLatestModificationOnUTC',
      latestModificationOnUTC,
      true,
    );

    return {
      ...state,
      enterprises,
      latestModificationOnUTC,
      isLoadingSelectedEnterprise: false,
    };
  }),

  on(changeEnterprise, (state, action) => {
    const enterpriseId: number = action.enterpriseId;
    const partialOfEnterprise: Partial<Enterprise> = action.enterprise;

    if (!state.enterprises || state.enterprises.length === 0) {
      return { ...state };
    }

    const enterprises = _.cloneDeep(state.enterprises);
    let enterpriseToChange = enterprises.find(
      (enterprise) => enterprise.id === enterpriseId,
    );

    if (!enterpriseToChange) {
      return { ...state };
    }

    enterpriseToChange = _.merge(enterpriseToChange, partialOfEnterprise);

    Utility.setStore('enterprises', enterprises, true);

    return {
      ...state,
      enterprises,
    };
  }),

  on(resetEnterprises, (state) => {
    Utility.removeStore('enterprises');
    Utility.removeStore('enterprisesLatestModificationOnUTC');

    return {
      ...state,
      enterprises: undefined,
      latestModificationOnUTC: undefined,
      isLoadingSelectedEnterprise: false,
    };
  }),

  on(triggerIsLoadingSelectedEnterprise, (state) => {
    return {
      ...state,
      isLoadingSelectedEnterprise: true,
    };
  }),
);

function compareStationType(stationA: Station, stationB: Station) {
  const stationTypeSortOrder = {
    [EnStationTypes.Hotel]: 0,
    [EnStationTypes.Restaurant]: 1,
    [EnStationTypes.Retail]: 2,
  };

  const valueA = stationTypeSortOrder[stationA.stationType];
  const valueB = stationTypeSortOrder[stationB.stationType];

  return valueA - valueB;
}
